module.exports = __webpack_public_path__ + "img/bunny_ears.c84821fd.jpg";